import { classNames } from "../../helpers";

const PageContainer = ({ title, cta, children }) => {
  return (
    <>
      <header className="bg-white">
        <div className={classNames(
          cta && 'flex items-center justify-between',
          'mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8'
        )}>
          <h1 className="text-3xl font-poppins font-medium tracking-tight text-gray-900">{title}</h1>
          { cta }
        </div>
      </header>
      <main>
        <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>
    </>
  )
}

export default PageContainer;
